module.exports = __webpack_public_path__ + "img/finger.b54907bf.png";